import React from "react";

const DebugTools = () => {
    return (
        <div id="debug-tools">
            <h3>Debug Tools</h3>

            <p>
                Use debugging blocks to help troubleshoot your Blockly script. These blocks allow you to inspect values, track errors, and understand how your app behaves during development and testing.
            </p>

            <div className="imageContainer">
                <img src="images/DebugToolBlocks.png" alt="Debug Tool Blocks Overview" />
            </div>

            <h4>Log to Console</h4>
            <p>
                Use the <strong>log to console</strong> block to output values to the browser console while previewing your app.
                To view the logs:
            </p>
            <ul>
                <li>Open the app in <em>Preview</em> mode.</li>
                <li>Right-click anywhere on the page and select <em>Inspect</em> or <em>Inspect Element</em>.</li>
                <li>Go to the <strong>Console</strong> tab in the developer tools.</li>
            </ul>
            <div className="imageContainer">
                <img src="images/DebugToolConsole.png" alt="Log to Console" />
            </div>

            <h4>Log Info to Device</h4>
            <p>
                Use the <strong>log info to device</strong> block to send messages to the app log once the app is published.
                To view the logs on a device:
            </p>
            <ul>
                <li>Open the app on your device.</li>
                <li>Click the 3-dot menu in the top-right corner.</li>
                <li>Select <strong>View Logs</strong>.</li>
            </ul>
            <div className="imageContainer">
                <img src="images/DebugToolDevice.png" alt="Log Info to Device" />
            </div>

            <h4>Log Error to Device</h4>
            <p>
                Use the <strong>log error to device</strong> block to send error messages to the app’s error log after publishing.
                To view error logs:
            </p>
            <ul>
                <li>Open the app on your device.</li>
                <li>Click the 3-dot menu in the top-right corner.</li>
                <li>Select <strong>View Logs</strong>.</li>
            </ul>
            <div className="imageContainer">
                <img src="images/DebugToolError.png" alt="Log Error to Device" />
            </div>
        </div>
    );
};

export default DebugTools;
